import React from 'react';

const About = () => {
    return (
        <div className="py-12 container mx-auto px-6 max-w-4xl">
            <div className="bg-white p-10 rounded-2xl shadow-sm border border-emerald-100">
                <h1 className="font-display text-4xl text-emerald-900 mb-8 text-center">The Story of Shep</h1>
                
                <div className="float-right ml-8 mb-8 w-48 h-48 bg-gray-200 rounded-full flex items-center justify-center text-gray-500 text-sm font-bold shadow-inner">
                    Shep's Photo
                </div>

                <div className="prose prose-lg text-gray-700">
                    <p className="mb-6">
                        Shep wasn't just a dog; he was a soul with a lot of big feelings. As a rescue Border Collie mix, he found the world a little overwhelming. Public dog parks were too chaotic, sidewalks were too stressful, and he just wanted a place to run without looking over his shoulder.
                    </p>
                    <p className="mb-6">
                        We built <strong>Shep's Sniff Spot</strong> in his honor. We realized that many dogs—whether reactive, elderly, in training, or just shy—need a sanctuary.
                    </p>
                    <h3 className="font-display text-2xl text-emerald-800 mt-8 mb-4">Our Mission</h3>
                    <p>
                        To provide a safe, secure, and judgment-free zone where dogs and their humans can bond, decompress, and experience the pure joy of freedom.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;